// extracted by mini-css-extract-plugin
export default {"container":"contest-block_container__10nS_","inner":"contest-block_inner__3p6h0","wait":"contest-block_wait__3pfmW"};